/**
 * A compact segmented button group — the terminal-register control used for
 * agenda tabs, range presets, reach-metric switches, etc. Extracted from the
 * hand-rolled copies in ShareTrendChart / PortalHome so every switcher looks
 * and behaves the same.
 */
export interface SegmentedOption<T extends string> {
  key: T;
  label: string;
}

export function Segmented<T extends string>({
  options,
  value,
  onChange,
  size = "md",
  className = "",
}: {
  options: readonly SegmentedOption<T>[];
  value: T;
  onChange: (v: T) => void;
  size?: "sm" | "md";
  className?: string;
}) {
  const pad =
    size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-[12px]";
  return (
    <div
      className={`flex gap-0.5 rounded-md border border-white/10 bg-terminal-panel p-0.5 ${className}`}
    >
      {options.map((o) => (
        <button
          key={o.key}
          type="button"
          onClick={() => onChange(o.key)}
          className={`rounded font-semibold transition-colors ${pad} ${
            value === o.key
              ? "bg-terminal-elevated text-terminal-ink"
              : "text-terminal-ink-muted hover:text-terminal-ink"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
